import React from 'react'
import Layout from '../components/Layout'
import styled from 'styled-components'
import Seo from '../components/SEO/PageSeo'

const Legal = () => {
  return (
    <Layout>
      <Seo />
      <Wrapper>
        <h1>Impressum</h1>
        <h2>Inhaltlich verantwortlich</h2>
        Jay Fischer
        <br />
        Lipper Weg 121
        <br />
        45772 Marl
        <h3>Email</h3>
        kontakt@inkfs.com
        <br />
        <h3>Telefon</h3>
        00 49 178 8 137 148
        <h2>Allgemeine Hinweise und Pflichtangaben</h2>
        <h3>Benennung der verantwortlichen Stelle</h3>
        Die verantwortliche Stelle für die Verarbeitung der Daten auf dieser
        Website ist: Ink und Feder Design Studios Jay Fischer Lipper Weg 121
        45772 Mergel Deutschland. Die zuständige Stelle entscheidet allein oder
        gemeinsam mit anderen die Zwecke und Mittel der Verarbeitung von
        personenbezogenen Daten (z. B. Namen, Adressen persönliche Daten (z.B.
        Namen, Kontaktdaten o.ä.).
        <h3>Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>. Einige
        Datenverarbeitungen sind nur mit Ihrer ausdrückliche Zustimmung. Ein
        Widerruf Ihrer bereits erteilten Einwilligung ist zu jeder Zeit möglich.
        Eine formlose Kommunikation per E-Mail ist ausreichend für ist für den
        Widerruf ausreichend. Die Rechtmäßigkeit der Datenverarbeitung bis zum
        Widerruf durchgeführt wird, ist vom Widerruf nicht betroffen.
        <h3>Recht auf Beschwerde bei der Aufsichtsbehörde Behörde</h3>. Als
        betroffene Person haben Sie das Recht, eine Beschwerde einzureichen an
        die zuständige Aufsichtsbehörde im Falle einer Verletzung von
        datenschutz. Die zuständige Aufsichtsbehörde für den Datenschutz ist der
        Datenschutzbeauftragte des Bundeslandes, in dem die des Bundeslandes, in
        dem unsere Gesellschaft ihren Sitz hat. Unternehmen angesiedelt ist.
        Unter dem folgenden Link finden Sie eine Liste der
        Datenschutzbeauftragten und deren Kontaktdaten und deren
        Kontaktinformationen:
        https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html.
        <h3>Recht auf Datenübertragbarkeit</h3>
        Sie haben das Recht, Daten an sich selbst oder an Dritte zurückzusenden
        automatisch von uns auf Basis Ihrer Einwilligung verarbeitet werden oder
        in Erfüllung eines Vertrages. Die Daten werden in einem lesbaren
        lesbares Format. Wenn Sie die direkte Übermittlung der Daten an einen
        anderen verantwortlich ist, wird dies nur insoweit geschehen, als es
        technisch möglich ist technisch möglich.
        <h3>Recht auf Auskunft, Berichtigung, Sperrung, Löschung</h3>
        Im Rahmen der geltenden gesetzlichen Bestimmungen haben Sie das Recht,
        jederzeit Recht auf unentgeltliche Auskunft über Ihre gespeicherten
        personenbezogenen Daten, die Herkunft der gespeicherten
        personenbezogenen Daten, die Herkunft der Daten, ihre Empfänger und den
        Zweck der Zweck der Datenverarbeitung und ggf. ein Recht auf
        Berichtigung, Sperrung oder diese Daten zu berichtigen, zu sperren oder
        zu löschen. Diesbezüglich, und auch für andere Fragen zum Thema
        personenbezogene Daten können Sie sich an uns wenden persönlichen Daten,
        können Sie sich jederzeit über die Kontaktmöglichkeiten an uns wenden
        Kontaktmöglichkeiten, die im Impressum angegeben sind.
        <h3>SSL- oder TLS-Verschlüsselung</h3>
        Aus Sicherheitsgründen und zum Schutz der Übertragung von vertrauliche
        Inhalte, die Sie an uns als Betreiber der Website senden, unsere Website
        verwendet unsere Website eine SSL- oder TLS-Verschlüsselung. Dies
        bedeutet, dass Daten, die Sie über diese Website übermitteln, können von
        Dritten nicht gelesen werden. von Dritten gelesen werden. Sie erkennen
        eine verschlüsselte Verbindung an der Adresszeile "https://" Ihres
        Browsers und das Schloss-Symbol im Browser in der Browserzeile.
        <h3>Server-Protokolldateien</h3>
        In Server-Protokolldateien kann der Website-Anbieter erhebt und
        speichert automatisch Informationen, die Ihr Browser automatisch an uns
        überträgt. Dies beinhaltet:
        <ul>
          <li>Besuchte Seite auf unserer Domain</li>.
          <li>Datum und Uhrzeit der Serveranfrage</li>.
          <li>Browser-Typ und Browser-Version</li>.
          <li>Betriebssystem verwendet</li>.<li>Die Referrer-URL</li>.
          <li>Hostname des zugreifenden Rechners</li>.<li>IP-Adresse</li>.
        </ul>
        Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht
        vorgenommen. Die Datenverarbeitung erfolgt auf Grundlage von Art. 6 Abs.
        1 lit. b DSGVO, der Verarbeitung von Daten zum Zwecke vertraglicher oder
        vorvertraglicher Maßnahmen. vorvertragliche Maßnahmen.
        <h3>Kontaktformular und Newsletter-Anmeldung</h3>
        Die über das Kontaktformular übermittelten Daten werden gespeichert,
        einschließlich Ihrer einschließlich Ihrer Kontaktdaten, um Ihre Anfrage
        bearbeiten zu können oder um für Folgefragen zur Verfügung zu stehen.
        Diese Daten werden nicht ohne Ihre Zustimmung übermittelt. Die
        Verarbeitung der im Kontaktformular eingegebenen Daten im
        Kontaktformular erfolgt ausschließlich auf Grundlage Ihrer Einwilligung
        (Art. 6 Abs. 1 DSGVO). Einwilligung (Art. 6, Abs. 1, lit. a DSGVO). Sie
        können Ihre Einwilligung jederzeit widerrufen. Die Einwilligung kann
        jederzeit widerrufen werden. Eine informelle Kommunikation Für den
        Widerruf genügt die Mitteilung per E-Mail. Die Rechtmäßigkeit der
        Datenverarbeitungsvorgänge und die Übersetzt mit
        www.DeepL.com/Translator (kostenlose Version)
      </Wrapper>
    </Layout>
  )
}

export default Legal

const Wrapper = styled.section`
  width: 85vw;
  max-width: 1100px;
  margin: 0 auto;
  margin-top: 5rem;
  margin-bottom: 4rem;
  h1,
  h2,
  h3,
  h4 {
    margin-top: 2rem;
  }
  ul {
    margin: 1rem;
  }
`
